import axios from "axios";
import domain from "@/util/domain.js";
import {
  getIntegrationIdByName,
  addUserIntegration
} from "./integrationsUtils.js";

const host = domain();
const headers = { "Content-Type": "application/json" };
// Stack sga-activecampaign-prod (us-east-2). Não há stack de dev em us-east-2:
// o "dev" fica nulo para que um operador de teste nunca grave no CRM de prd.
const baseLambdaURLs = {
  dev: null,
  prod: "https://43aaklxcw2.execute-api.us-east-2.amazonaws.com",
};
let operator;
const activeCampaignIntegrationId = getIntegrationIdByName("activeCampaign");

//? Constructor Active Campaign (ac)
//* https://developers.activecampaign.com/reference/overview
class ActiveCampaign {
  constructor(
    activeCampaignActive = false,
    createContact = false,
    updateContact = false,
    firstDeposit = false,
    baseLambdaURL = baseLambdaURLs.prod
  ) {
    this.activeCampaignActive = activeCampaignActive;
    this.baseLambdaURL = baseLambdaURL;
    this.createContact = createContact;
    this.updateContact = updateContact;
    this.firstDeposit = firstDeposit;
  }
}

//? Integrando ao Vue
export default {
  install(Vue) {
    Vue.prototype.$activeCampaign = async (action, userData, userId) => {
      //? Montando o Construtor do operador
      switch (host) {
        case "sysbet":
          operator = new ActiveCampaign(false, true, true, true, baseLambdaURLs.dev);
          break;
        case "":
          //! Em caso de novos operadores que utilizam o ActiveCampaign
          //! 1 - Adicione o "domain" em um "case" acima
          //! 2 - Descomente o código abaixo
          // operator = new ActiveCampaign(true, true, true, true);
          break;
        default:
          operator = new ActiveCampaign();
      }

      if (!operator.activeCampaignActive) return;

      //? Criação de Contato - createContact
      if (action === "createContact" && operator.createContact) {
        //! E-mail obrigatório para criação de um contato
        if (!userData.email) return;

        const responseCreateContact = await createContact(userData);

        if (responseCreateContact.status !== 200) return;

        // Adicionando ID do usuário do ActiveCampaign no banco de dados para
        // que quando o usuário confirmar sua conta, esse ID seja utilizado para
        // atualizar o status de confirmação de conta nos dados do usuário no
        // activeCampaign
        const userIdActiveCampaign = responseCreateContact.data.integration_id;

        addUserIntegration(userId, userIdActiveCampaign, "activeCampaign");
      }

      //? Confirmação de Conta - confirmRegister
      if (action === "confirmRegister" && operator.updateContact) {
        const userIntegrations = userData.integrations;

        if (userIntegrations && userIntegrations.length !== 0) {
          const hasIntegrationId = userIntegrations.find((integration) => {
            const { integration_id, user_integration_id } = integration;

            return activeCampaignIntegrationId === integration_id &&
              user_integration_id;
          });

          if (!hasIntegrationId) return;

          const userDataWithIntegrationId = {
            ...userData,
            integration_id: hasIntegrationId.user_integration_id
          };

          const responseUpdateUser =
            await updateContact(userDataWithIntegrationId, "false");

          if (responseUpdateUser.status !== 200) return;
        }

        return;
      }

      //? Primeiro Depósito - firstDeposit
      if (action === "firstDeposit" && operator.firstDeposit) {
        Vue.prototype.$axios.post(
          "/player/profile/findPlayerIntegrationId",
          Vue.prototype.$formdata({ integration_id: activeCampaignIntegrationId })
        ).then(async resp => {
          const respUserData = resp.data.dados;

          if (
            !respUserData.user_integration_id ||
            !respUserData.email
          ) return;

          const userDataWithIntegrationId = {
            ...respUserData,
            nome: respUserData.name,
            celular: respUserData.phone,
            integration_id: respUserData.user_integration_id,
          };

          const responseUpdateUser =
            await updateContact(userDataWithIntegrationId, "true");

          if (responseUpdateUser.status !== 200) return;
        }).catch(() => {});
      }
    };
  }
};

//? Create Contact
//* https://developers.activecampaign.com/reference/create-a-new-contact
const createContact = async (userData) => {
  return new Promise(function (resolve, reject) {
    const body = bodyUserData(userData, false, "false", "true", "false");

    axios
      .post(`${operator.baseLambdaURL}/ac/createContact`, body, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(err));
  });
};

//? Update Contact
//* https://developers.activecampaign.com/reference/update-a-contact-new
const updateContact = async (userData, boolDeposit) => {
  return new Promise(function (resolve, reject) {
    const body = bodyUserData(
      userData,
      userData.integration_id,
      "true",
      "false",
      boolDeposit
    );

    axios
      .post(`${operator.baseLambdaURL}/ac/updateContact`, body, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(err));
  });
};

//? Format Body User Data
const bodyUserData = (userData, ac_user_id, CC, CP, DR) => {
  //* CC String+boolean (Cadastro Completo)
  //* CP String+boolean (Cadastro Pendente)
  //* DR String+boolean (Primeiro Deposito Realizado)
  let user = {
    "contact": {
      "email": userData.email,
      "firstName": userData.nome.split(" ")[0],
      "lastName": userData.nome.split(" ")[1],
      "phone": userData.celular,
    }
  }

  //* HANDLER Custom Fields
  //* https://developers.activecampaign.com/reference/create-a-new-contact
  //* Reference a custom field by id, not the custom field's name/title.
  //* When writing to a Contact's custom data, the field must be the id of a previously-created custom field, not the custom field's name / title.

  //* Cada operador que tiver seu AC ativado, vai lidar com os custom fields de acordo com seus ids;
  switch (host) {
    case "pingolbet":
    case "sys":
      user.contact.fieldValues = [
        // CADASTRO_COMPLETO
        {
          "field": "15",
          "value": CC
        },
        // CADASTRO_PENDENTE
        {
          "field": "16",
          "value": CP
        },
        // DEPOSITO_REALIZADO
        {
          "field": "17",
          "value": DR
        }
      ];
      break;
    case "zep":
      user.contact.fieldValues = [
        // CADASTRO_COMPLETO
        {
          "field": "11",
          "value": CC
        },
        // CADASTRO_PENDENTE
        {
          "field": "12",
          "value": CP
        },
        // DEPOSITO_REALIZADO
        {
          "field": "13",
          "value": DR
        }
      ];
      break;
    case "jogodeourobet":
      user.contact.fieldValues = [
        // CADASTRO_COMPLETO
        {
          "field": "1",
          "value": CC
        },
        // CADASTRO_PENDENTE
        {
          "field": "2",
          "value": CP
        },
        // DEPOSITO_REALIZADO
        {
          "field": "3",
          "value": DR
        }
      ];
      break;
    default:
      user.fieldValues = [];
  }

  //? Body
  const body = {
    domain: host,
    user,
    ac_user_id: ac_user_id ? ac_user_id : false,
  };

  return body;
};